<template>
  <div class="home">
    <h2 class="text-center d-flex justify-center mt-10">
      {{ name }}, SEJA BEM VINDO(A) AO SISTEMA CHAPLIN!
    </h2>
    <v-divider class="mb-10"></v-divider>
    <v-row v-if="typeUser === 'admin'">
      <v-col>
        <v-card class="mx-auto" max-width="450">
          <v-card-text>
            <p class="text-h5 text--primary">EMPRESAS</p>
            <p class="text-subtitle-1">Empresas ativas no sistema</p>
            <div class="text--primary">
              <v-row>
                <v-col>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="item in typeCompanies" :key="item.type">
                          <td class="text-h6">{{ item.name }}</td>
                          <td class="font-weight-bold text-h6 text-right">
                            {{ item.count }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions>
            <!-- <v-btn text color="deep-purple accent-4"> SAIBA MAIS </v-btn> -->
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <!--   <v-col>
        <v-card class="mx-auto" max-width="600">
          <v-card-text>
            <div>HISTORICO DE PEDIDOS</div>
            <p class="text-h4 text--primary">PEDIDOS</p>
            <p>EM ABERTO</p>
            <div class="text--primary">
              AQUI PODE VIM UM GRÁFICO OU RELATÓRIO MOSTRANDO ALGUMA INFORMAÇÃO
              IMPORTANTE DE PEDIDOS
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="deep-purple accent-4"> SAIBA MAIS </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="mx-auto" max-width="600">
          <v-card-text>
            <div>ROYALTIES A PAGAR</div>
            <p class="text-h4 text--primary">ROYALTIES</p>
            <p>07/10/2021</p>
            <div class="text--primary">
              DETALHAMENTO DE COBRANÇA OU ALGUMA OUTRA INFORMAÇÃO IMPORTANTE
              <br />
              <br />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="deep-purple accent-4"> SAIBA MAIS </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import * as HTTP from "@/api/requests/base";

import * as CompanyAPI from "@/api/requests/CompanyRequest";

export default {
  name: "Home",
  data: () => ({
    name: "",
    typeUser: "",
    typeCompanies: [
      { type: "franchise", name: "Franquias Ativas", count: 0 },
      { type: "provider", name: "Fornecedores Ativas", count: 0 },
      { type: "multibrand", name: "Multimarcas Ativas", count: 0 },
    ],
    board_active: {
      providers: 0,
      franchises: 0,
      multibrands: 0,
    },
  }),
  components: {},
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getNameForSessionStorage();
    },
    getNameForSessionStorage() {
      let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
      if (session) {
        session = JSON.parse(session);
        if (session.user !== "") {
          this.name = session.user.name.toUpperCase();
          this.typeUser = session.user.type;
          if (this.typeUser === "admin") {
            this.getCompanies();
          }
        }
      }
    },
    async getCompanies() {
      try {
        let res = await CompanyAPI.getAll();
        let data = res.filter((item) => item.status === 1);
        this.typeCompanies[0].count = data.filter(
          (item) => item.type === "fra"
        ).length;
        this.typeCompanies[1].count = data.filter(
          (item) => item.type === "for"
        ).length;
        this.typeCompanies[2].count = data.filter(
          (item) => item.type === "mul"
        ).length;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
